import { JSX } from "react";
import { Link } from "react-router-dom";

interface GroupCardProps {
  title: string;
  link: string;
  imageSrc: string;
}

const KidsGroupCard = ({ title, link, imageSrc }: GroupCardProps): JSX.Element => {
  return (
    <Link
      to={link}
      title={title}
      className={
        "responsive-transition relative flex aspect-[300/300] flex-col items-center justify-between gap-2 overflow-hidden rounded-[1.25rem] bg-surface-bright px-5 pt-[1.3rem] hover:bg-surface-container active:bg-surface-container"
      }
    >
      <img src={imageSrc} alt={title} loading={"lazy"} className={"absolute bottom-0 top-0 w-full object-cover"} />
      <span
        className={
          "responsive-transition z-1 relative line-clamp-2 text-center text-xl font-semibold leading-6 max-md:text-lg max-md:leading-[1.125rem]"
        }
      >
        {title}
      </span>
    </Link>
  );
};

export default KidsGroupCard;
